import React from 'react';
import PropTypes from 'prop-types';
import { useImageStyles } from './imageStyles';

export default function Image(props) {
  const { src, ...rest } = props;
  const classes = useImageStyles(props);

  return (
    <img
      className={classes.image}
      src={src}
      alt={props.alt ? props.alt : ''}
      {...rest}
    />
  );
}

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};
